var map = {
	"./CurationListDefaultLayout": [
		"1270",
		"chunk-1edb16ef"
	],
	"./CurationListDefaultLayout.vue": [
		"1270",
		"chunk-1edb16ef"
	],
	"./CurationListHistoryLayout": [
		"d1cd",
		"chunk-2d21da64"
	],
	"./CurationListHistoryLayout.vue": [
		"d1cd",
		"chunk-2d21da64"
	],
	"./CurationListReceiveLayout": [
		"533c",
		"chunk-3a40ddaf"
	],
	"./CurationListReceiveLayout.vue": [
		"533c",
		"chunk-3a40ddaf"
	],
	"./CurationListRequestLayout": [
		"1820",
		"chunk-e115f9cc"
	],
	"./CurationListRequestLayout.vue": [
		"1820",
		"chunk-e115f9cc"
	],
	"./CurationListSendLayout": [
		"4fea",
		"chunk-ad337ee2"
	],
	"./CurationListSendLayout.vue": [
		"4fea",
		"chunk-ad337ee2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6ea2";
module.exports = webpackAsyncContext;